import firebase from 'firebase/app';
import 'firebase/database';

const config = {
    apiKey: "AIzaSyBGlKpJAv0I9cetNAycMWRxTztFWL1ZmOU",
    databaseURL: "https://fraloo-666.firebaseio.com",
    projectId: "fraloo-666"
};
export default firebase.initializeApp(config);